
<div class="modal-header">
<!-- <h2 mat-dialog-title></h2> -->

  <button mat-icon-button class="custom-close-button" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
<div style="text-align: center;">  
  <img [src]="data.product.image_Name" alt="..." (error)="onImgError($event)">
</div>
  <h5>{{data.product.item_Name}}</h5>
  <p>{{data.product.item_Description}}</p>
  <p style="color: rgb(0, 191, 255) ;"><strong>Price: </strong>{{data.product.total_Costs_In_Local_Currency}} {{data.product.currency_Code}} </p>
  <!-- <p><strong>SKU:</strong> {{data.product.item_SKU}} </p> -->

</mat-dialog-content>
<mat-dialog-actions>
  <div class="col-12 text-center" *ngIf="data.isAddToCart">
    <button mat-raised-button (click)="addToCart(data.product)">Add to cart</button>
  </div>

  <div class="col-12 text-center" *ngIf="data.isAddedToCart">
    <button mat-raised-button style="color: green;" (click)="cart()">View cart</button>
    <p>Item successfully added to cart!</p>
  </div>

</mat-dialog-actions>
